// extracted by mini-css-extract-plugin
module.exports = {"typeSelection":"styles_typeSelection__wXLOG","toggleSelected":"styles_toggleSelected__3CxJ_"};